// eslint-disable-next-line import/prefer-default-export
export enum RequestState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
  ERROR = 'ERROR',
}
